import React, { useEffect } from "react";
import { getClasses } from "../../utils";
import classes from "./PasswordStrengthBar.module.css";
import zxcvbn from "zxcvbn";

type Props = {
  password: string;
  setStrongPassword?: any;
};

const PasswordStrengthBar: React.FC<Props> = ({
  password,
  setStrongPassword,
}) => {
  const strengthScore: any = zxcvbn(password).score;

  const strength =
    strengthScore === 1
      ? "Too Weak"
      : strengthScore === 2
      ? "Weak"
      : strengthScore === 3
      ? "Good"
      : strengthScore === 4
      ? "Strong"
      : "";

  useEffect(() => {
    setStrongPassword?.(strengthScore >= 3);
  }, [strengthScore]);

  return (
    <>
      <div className={classes.wrapper}>
        {["Very Weak", "Weak", "Good", "Strong"].map((_, index) => (
          <div
            key={index}
            className={getClasses(
              classes.bar,
              index < strengthScore ? classes["strength" + strengthScore] : ""
            )}
          />
        ))}
      </div>
      <div className={classes.labelContainer}>
        {strength && (
          <span
            className={getClasses(
              classes.label,
              classes["label" + strengthScore]
            )}>
            {strength}
          </span>
        )}
      </div>
    </>
  );
};

export default PasswordStrengthBar;

const evaluatePasswordStrength = (password: string) => {
  if (!password) return 0;

  // Check the conditions for medium strength
  const hasLowerCase = /[a-z]/.test(password);
  const hasUpperCase = /[A-Z]/.test(password);
  const hasDigit = /\d/.test(password);
  const hasSpecialChar = /[^A-Za-z0-9]/.test(password);
  const isAtLeast8Chars = password.length >= 8;
  const isAtLeast12Chars = password.length >= 12;

  const isMedium =
    hasLowerCase &&
    hasUpperCase &&
    hasDigit &&
    hasSpecialChar &&
    isAtLeast8Chars;
  const isStrong = isMedium && isAtLeast12Chars;

  if (isStrong) {
    return 3; // Strong password
  } else if (isMedium) {
    return 2; // Medium password
  } else {
    return 1; // Weak password
  }
};
